// extracted by mini-css-extract-plugin
module.exports = {"Button":"Share_Button__3mW3F","Permissions":"Share_Permissions__3X6bE"};